import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'
import { IResetPasswordFormValues } from 'features/Login/types'
import schemaValidations from 'utils/schema'

const usernameMessages = defineMessages({
  required: {
    id: 'login.schema.pwdMatch',
    defaultMessage: 'Password does not match'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IResetPasswordFormValues> => {
  return yup.object().shape({
    confirmPassword: yup
      .string()
      .required(intl.formatMessage(usernameMessages.required))
      .when('$', {
        is: (value: IResetPasswordFormValues): boolean => {
          const { password, confirmPassword } = value
          return password !== confirmPassword
        },
        then: yup.string().oneOf([yup.ref('password')], intl.formatMessage(usernameMessages.required))
      }),
    password: schemaValidations(intl).password.required
  })
}
